/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useContext, useEffect, useState } from "react";
import { formatTimeToISO } from "formatters";
import { useImageProxy } from "hooks/useImageProxy";
import { get } from "lodash";
import { useRouter } from "next/router";
import { ArticleContext } from "providers/Article";
import { searchArticleCid } from "providers/ArticleScroll/searchArticleCid";
import { ServerSidePropsContext } from "providers/ServerSideProps";
// import { enviarScroll, enviarPageView } from "hooks/useGCJAnalytics";
import { decrypt } from "utils/ecryption";
import { useKeycloak } from "@react-keycloak/ssr";
import { KeycloakInstance } from "keycloak-js";
import { getPageTitleFromPath } from '../../utils/getDepFromNav'

type ArticleScrollContextType = {
  state: any;
};

export const ArticleScrollContext = createContext<ArticleScrollContextType>(
  {} as ArticleScrollContextType
);

type CustomizedElement = (Element & { content?: string }) | null;

const ArticleScrollProvider = (props) => {
  const serverSideContext = useContext(ServerSidePropsContext);
  const articleContext = useContext(ArticleContext);
  const { keycloak } = useKeycloak<KeycloakInstance>();
  const router = useRouter();
  const [state, setState] = useState({});
  const scrollListenerController = new AbortController();

  let privateViewedState: Array<string> = [];

  function calculatePos(elements) {
    const keys = Object.keys(elements);
    const state = {};
    keys.forEach((i, k) => {
      const articleElement = elements[i];
      const elementArticleId = articleElement.dataset.articleId;
      const elementArticleUrl = articleElement.dataset.articleUrl;
      const elementHeight = articleElement.clientHeight;
      const pos = articleElement.getBoundingClientRect();
      const topGutter = 198;
      state[elementArticleId] = {
        viewing: k === 0 ? true : false,
        viewed: false,
        top: (pos.top - topGutter) * -1,
        bottom: pos.bottom,
        height: elementHeight,
        progress: 0,
        url: elementArticleUrl,
      };
    });
    return state;
  }

  const nav = serverSideContext.navigation || {};
  const fullNav: any = [];
  const prevNav = [...nav?.menuActions, ...nav?.menuSide, ...nav?.menuTop];
  let lastArticleId = "";
  let lastAnalyticsScroll = -1;
  for (let i = 0; i < prevNav.length; i++) {
    const it = prevNav[i];
    fullNav.push({
      name: it?.name,
      path: it?.path,
    });
    const subItems: any = it?.subItems || [];
    for (let j = 0; j < subItems.length; j++) {
      const sit = subItems[j];
      fullNav.push({
        name: sit?.name,
        path: sit?.path,
      });
    }
  }

  function parseArticleKeywords(tags) {
    if (!tags) {
      return "";
    }
    return tags.join(", ");
  }

  function parseMainSection(path) {
    const navItems = path ? getPageTitleFromPath(fullNav, path) : [];
    return navItems[0] ? navItems[0] : "";
  }

  function handleScroll() {
    const elements = window.document.querySelectorAll(
      'div[data-component-type="article"]'
    );
    const s = calculatePos(elements);
    const keys = Object.keys(s);
    const newState = {};

    keys.forEach((k, index) => {
      const i = s[k];
      const x = (i.top * 100) / i.height;
      const percentageViewed = Number(x.toFixed(3));
      const progress =
        percentageViewed > 100
          ? 100
          : percentageViewed < 0
          ? 0
          : percentageViewed;
      const progressAnalytics = Math.floor(progress);
      const percentSendAnalytics = progressAnalytics % 10;
      const isViewing = x > 0 && x < 100;
      const isViewed = x > 100;

      //[AVISO]: Script de analytics está sendo desabilitado para usar Chartbeat e Google Analytics para gerar os dados no BI,
      // quando confirmado a migração, remover.
      // if (
      //   isViewing &&
      //   percentSendAnalytics === 0 &&
      //   lastAnalyticsScroll !== progressAnalytics
      // ) {
      //   const articleId = serverSideContext.article[index].id.replace(
      //     "policy:",
      //     ""
      //   );
      //   if (lastArticleId !== articleId) {
      //     lastArticleId = articleId;
      //     enviarPageView({
      //       referer: window?.location?.href,
      //       contentId: articleId,
      //     });
      //   }
      //   //[AVISO]: Script de analytics está sendo desabilitado para usar Chartbeat e Google Analytics para gerar os dados no BI,
      //   // quando confirmado a migração, remover.
      //   // enviarScroll(progressAnalytics, articleId);
      //   lastAnalyticsScroll = progressAnalytics;
      // }

      if (isViewing && window.location.pathname !== i.url) {
        window.history.replaceState({}, k, i.url);

        for (let index = 0; index < articleContext.articles.length; index++) {
          const site = serverSideContext.site;
          const domain = serverSideContext.domain;
          const page = serverSideContext.page;
          const article = get(articleContext.articles, index, {});
          const articlePath = get(article, "path");
          const articleImage = article.images.length
            ? `${domain}${useImageProxy(`${article.images[0].url}f=3x2`, true)}`
            : "";
          const itemPath = get(i, "url");
          if (articlePath === itemPath) {
            const title: CustomizedElement =
              window.document.head.querySelector("title");
            const meta_description: CustomizedElement =
              window.document.head.querySelector('meta[name="description"]');
            const meta_article_modified_time: CustomizedElement =
              window.document.head.querySelector(
                'meta[property="article:modified_time"]'
              );
            const meta_article_published_time: CustomizedElement =
              window.document.head.querySelector(
                'meta[property="article:published_time"]'
              );
            const meta_og_image: CustomizedElement =
              window.document.head.querySelector('meta[property="og:image"]');
            const meta_og_image_secure_url: CustomizedElement =
              window.document.head.querySelector(
                'meta[property="og:image:secure_url"]'
              );
            const meta_og_description: CustomizedElement =
              window.document.head.querySelector(
                'meta[property="og:description"]'
              );
            const meta_og_title: CustomizedElement =
              window.document.head.querySelector('meta[property="og:title"]');
            const meta_og_url: CustomizedElement =
              window.document.head.querySelector('meta[property="og:url"]');
            const meta_twitter_image: CustomizedElement =
              window.document.head.querySelector('meta[name="twitter:image"]');
            const meta_twitter_title: CustomizedElement =
              window.document.head.querySelector('meta[name="twitter:title"]');
            const meta_twitter_description: CustomizedElement =
              window.document.head.querySelector(
                'meta[name="twitter:description"]'
              );

            const responsavel: CustomizedElement =
              window.document.head.querySelector('meta[name="responsavel"]');
            const articleEditoria: CustomizedElement =
              window.document.head.querySelector(
                'meta[name="article:editoria"]'
              );
            const imageUrl: CustomizedElement =
              window.document.head.querySelector('meta[name="gjc:rec:image"]');
            const sectionUrl: CustomizedElement =
              window.document.head.querySelector(
                'meta[name="cXenseParse:recs:ojc-sectionurl"]'
              );
            const section: CustomizedElement =
              window.document.head.querySelector(
                'meta[name="article:section"]'
              );
            const author: CustomizedElement =
              window.document.head.querySelector('meta[name="author"]');
            const keywords: CustomizedElement =
              window.document.head.querySelector('meta[name="keywords"]');

            const articleName =
              article.metadataTitle !== ""
                ? article.metadataTitle
                : `${article.name} | ${site.name}`;
            const articleDescription =
              article.metadataDescription !== ""
                ? article.metadataDescription
                : article.lead;
            const articlePublishedDate = formatTimeToISO(
              article?.modificationTime
            );
            const articleModifiedDate = formatTimeToISO(
              article?.publishingTime
            );
            const articleUrl = `${domain}${article.path}`;

            if (title) {
              title.innerHTML = articleName;
            }
            if (meta_description) {
              meta_description.content = articleDescription;
            }
            if (meta_article_modified_time) {
              meta_article_modified_time.content = articleModifiedDate;
            }
            if (meta_article_published_time) {
              meta_article_published_time.content = articlePublishedDate;
            }
            if (meta_og_image) {
              meta_og_image.content = articleImage;
            }
            if (meta_og_image_secure_url) {
              meta_og_image_secure_url.content = articleImage;
            }
            if (meta_og_description) {
              meta_og_description.content = articleDescription;
            }
            if (meta_og_title) {
              meta_og_title.content = articleName;
            }
            if (meta_og_url) {
              meta_og_url.content = articleUrl;
            }
            if (meta_twitter_image) {
              meta_twitter_image.content = articleImage;
            }
            if (meta_twitter_title) {
              meta_twitter_title.content = articleName;
            }
            if (meta_twitter_description) {
              meta_twitter_description.content = articleDescription;
            }
            if (responsavel) {
              responsavel.content = article?.author?.name
                ? article.author.name
                : article.byline;
            }
            if (articleEditoria) {
              articleEditoria.content = page.name;
            }
            if (imageUrl) {
              imageUrl.content = articleImage;
            }
            if (sectionUrl) {
              sectionUrl.content = `${site.siteDomain}${page.path}`;
            }
            if (section) {
              section.content = parseMainSection(page.path);
            }
            if (author) {
              author.content = article?.author?.name
                ? article.author.name
                : article.byline;
            }
            if (keywords) {
              keywords.content = parseArticleKeywords(
                article?.tags?.tags || null
              );
            }
          }
        }
      }

      newState[k] = {
        viewing: isViewing,
        viewed: isViewed,
        top: i.top,
        bottom: i.bottom,
        height: i.height,
        progress: progress,
        url: i.url,
      };
    });
    setState(newState);
  }

  useEffect(() => {
    const pageType = searchArticleCid(window.location.pathname);
    if (pageType?.type === "article" && articleContext.isLoaded === true) {
      window.addEventListener("scroll", () => handleScroll(), {
        signal: scrollListenerController.signal,
      });
      window.scrollTo(0, 1);
    }
    return () => {
      scrollListenerController.abort();
    };
  }, [articleContext.isLoaded]);

  useEffect(() => {
    scrollListenerController.abort();
  }, [router.asPath]);

  useEffect(() => {
    let tp = window.tp || [];
    tp.push(["setPageURL", window.location.href]);

    if (keycloak) {
      tp.pianoId?.loginByToken(decrypt(keycloak.token)).then(() => {
        tp.experience?.execute();
      });
    } else {
      if (tp?.pianoId?.getUser() !== null) {
        tp?.pianoId?.logout();
      }
      tp.experience?.execute();
    }
  }, [window.location.href]);

  return (
    <ArticleScrollContext.Provider value={{ state }}>
      {props.children}
    </ArticleScrollContext.Provider>
  );
};

export default ArticleScrollProvider;
